import { Display, Map } from "rot-js"

import { maps } from "../data/map"
import { MapID, MapType } from "../defines/enums"
import { MapData, Offset } from "../defines/types"
import { DynamicMap } from "../map/dynamicmap"
import { Room } from "../map/room"
import { StaticMap } from "../map/staticmap"
import { TapestryMap } from "../map/tapestrymap"
import { FLOOR_TILE, Tile, WALL_TILE } from "../map/tile"
import { Player } from "../player/player"

// function diggerOptions(
//   roomWidthRange: [number, number],
//   roomHeightRange: [number, number],
//   dugPercentage: number,
//   timeLimit: number
// ) {
//   return {
//     roomWidth: roomWidthRange,
//     roomHeight: roomHeightRange,
//     dugPercentage: dugPercentage,
//     timeLimit: timeLimit,
//   }
// }

function uniformOptions(
  roomWidthRange: [number, number],
  roomHeightRange: [number, number],
  dugPercentage: number,
  timeLimit: number
) {
  return {
    roomWidth: roomWidthRange,
    roomHeight: roomHeightRange,
    roomDugPercentage: dugPercentage,
    timeLimit: timeLimit,
  }
}

function generateRandomMap(
  mapWidth: number,
  mapHeight: number,
  roomWidthRange: [number, number],
  roomHeightRange: [number, number],
  dugPercentage: number,
  timeLimit: number
): [Room[], Tile[][]] {
  // TODO: try different ROT.Map generators
  //
  const map = new Map.Uniform(
    mapWidth,
    mapHeight,
    uniformOptions(roomWidthRange, roomHeightRange, dugPercentage, timeLimit)
  )
  // const map = new Map.Digger(
  //   mapWidth,
  //   mapHeight,
  //   diggerOptions(roomWidthRange, roomWidthRange, dugPercentage, timeLimit)
  // )

  // tileset is the full width and height
  let tiles: Tile[][] = new Array(mapHeight)
  for (let i = 0; i < mapHeight; ++i) {
    tiles[i] = new Array(mapWidth)
  }

  map.create((x, y, contents) => {
    if (contents == 0) {
      tiles[y][x] = { ...FLOOR_TILE }
    } else {
      tiles[y][x] = { ...WALL_TILE }
    }
  })

  let rooms: Room[] = []
  map.getRooms().forEach((room) => {
    const width = room.getRight() - room.getLeft()
    const height = room.getBottom() - room.getTop()
    const newRoom = new Room(room.getLeft(), room.getTop(), width, height)
    rooms.push(newRoom)
  })

  return [rooms, tiles]
}

function getMapData(mapID: MapID) {
  switch (mapID) {
    case MapID.Playground:
      return maps.playground
    case MapID.January:
      return maps.january
    case MapID.February:
      return maps.february
    case MapID.March:
      return maps.march
    case MapID.April:
      return maps.april
    case MapID.May:
      return maps.may
    case MapID.June:
      return maps.june
    case MapID.July:
      return maps.july
    case MapID.August:
      return maps.august
    case MapID.September:
      return maps.september
    case MapID.October:
      return maps.october
    case MapID.November:
      return maps.november
    case MapID.December:
      return maps.december
    case MapID.Portals:
    default:
      return maps.portals
      break
  }
  return maps.portals
}

function makeMap(
  mapID: MapID,
  mapData: MapData,
  display: Display,
  player: Player,
  offsets: Offset
): TapestryMap {
  if (mapData.type == MapType.STATIC) {
    return new StaticMap(mapData, mapID, display, player)
  } else {
    return new DynamicMap(mapData, mapID, display, player, offsets)
  }
}
function mapIDToString(mapID: MapID): string {
  let mapString = "Central Chamber"
  if (mapID == MapID.Playground) {
    mapString = "Playground"
  } else if (mapID == MapID.January) {
    mapString = "January"
  } else if (mapID == MapID.February) {
    mapString = "February"
  } else if (mapID == MapID.March) {
    mapString = "March"
  } else if (mapID == MapID.April) {
    mapString = "April"
  } else if (mapID == MapID.May) {
    mapString = "May"
  } else if (mapID == MapID.June) {
    mapString = "June"
  } else if (mapID == MapID.July) {
    mapString = "July"
  } else if (mapID == MapID.August) {
    mapString = "August"
  } else if (mapID == MapID.September) {
    mapString = "September"
  } else if (mapID == MapID.October) {
    mapString = "October"
  } else if (mapID == MapID.November) {
    mapString = "November"
  } else if (mapID == MapID.December) {
    mapString = "December"
  }
  return mapString
}

export { generateRandomMap, getMapData, makeMap, mapIDToString, uniformOptions }
